<script>
    import { onMount, tick } from "svelte";
    import Chart from 'chart.js/auto';
    import Gradient from "../../../../services/gradient.js";
    import { locale, format } from "svelte-i18n";


    let { vulnerabilities = [] } = $props();

    let canvas = $state();
    let chart;
    let totals = {};
    let tooltips_titles = {};

    const getColorsArray = () => {
        let colors = new Gradient()
            .setColorGradient("#343a40","#3c8dbc") // opcion 1
            .setMidpoint((vulnerabilities.length < 2) ? 2 : vulnerabilities.length)
            .getColors();
        ;
            for(let [index, color] of colors.entries()){
                colors[index] = color + "AE";
            }
        return colors;
    }

    let gradientArray = $derived(()=>getColorsArray());

    onMount(async () => {
        if(vulnerabilities.length > 1){
            getColorsArray();
        }
        await tick();

        let context  = canvas.getContext('2d');

        let chartData = {
            labels   : [],
            datasets : {
                backgroundColor : gradientArray ? gradientArray : ["#343a40AE","#3c8dbcAE"],
                data: [],
            },
        }


        for (const vul of vulnerabilities) {
            let title = "";
            title = $locale == "es" ? (vul.title_es.length > 25 ? vul.title_es.substring(0, 25) + "..." : vul.title_es) : (vul.title.length > 25 ? vul.title.substring(0, 25) + "..." : vul.title);
            chartData.labels.push(title);
            tooltips_titles[title] = $locale == 'es' ? vul.title_es : vul.title;
            chartData.datasets.data.push(vul.count_by_status.open + vul.count_by_status.accepted);
        }

        chart = new Chart(context, {
            type: 'bar',
            options: {
                barThickness: 50,
                // Elements options apply to all of the options unless overridden in a dataset
                // In this case, we are setting the border of each horizontal bar to be 2px wide
                elements: {
                    bar: {
                        inflateAmount: 1,
                        borderWidth: 0,
                        borderRadius: 2
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                aspectRatio: 1,
                plugins:{
                    legend: {
                        display: false,
                        position: 'bottom',
                        labels: {
                            font: {
                                fontFamily: 'Montserrat',
                                size: 12
                            }
                        }
                    },
                    tooltip:{
                        callbacks: {
                            title: function(tooltipItem) {
                                return tooltips_titles[tooltipItem[0].label];
                            },
                            fontFamily: 'Montserrat'
                        }
                    },
                },
                title: {
                    display: false,
                },
                animation : {
                    animateScale: true,
                    animateRotate: true,
                },
                scales: {
                    y: {
                        beginAtZero : true,
                        min: 0,
                        ticks: {
                            stepSize: 1,
                            font: {
                                family: 'Montserrat'
                            }
                        }
                    },
                    x: {
                        ticks: {
                            font: {
                                family: 'Montserrat',
                            },
                            display: true,
                            //maxRotation: 0,
                            //position: "right",
                        },
                    },
                },
                onHover : (event) => {
                    canvas.style.cursor = "pointer";
                },
                onClick: (event)=> {
                    let id = vulnerabilities.filter(vul=>(event.chart.tooltip.title[0] == vul.title_es) || event.chart.tooltip.title[0] == vul.title)[0].id;
                    window.location.href = `vulnerability/${id}`
                }
            },
            data : {
                labels  : chartData.labels,
                datasets: [chartData.datasets],
                borderWidth: 2,
                borderRadius: 5,
                borderSkipped: false,
            },
        });
    });
</script>
<style>
    /*#chart-vuls-by-severity {
        height: 250px !important;
        margin: 0 auto;
        width: 808px;
    }*/
</style>
<canvas bind:this={canvas} id="chart-vuls-by-severity" class:chart-has-no-data="{vulnerabilities.length < 1}" ></canvas>
